























































import IQuestion from "@/typings/IQuestion";
import IResponse from "@/typings/IResponse";
import anime, { AnimeInstance } from "animejs";
import "lazysizes";
import { Component, Prop, Vue } from "vue-property-decorator";

/**
 * Survey question format with multiple text choices.
 */
@Component
export default class QuestionChoice extends Vue {
  @Prop() private question!: IQuestion;
  @Prop() private index!: number;

  private readonly DURATION = 600;
  private readonly EASING = "easeInOutCubic";

  private answerId: number | null = null;
  private questionFadeOut!: AnimeInstance;
  private questionFadeIn!: AnimeInstance;

  /**
   * The base app URI configured in env.
   */
  private get apiUri(): string | undefined {
    return process.env.VUE_APP_API_URI;
  }

  private get deck(): IQuestion[] {
    return this.$store.getters.deck;
  }

  /**
   * Returns true if all survey questions have been answered.
   */
  private get isLastQuestion(): boolean {
    return this.index === this.deck.length - 1;
  }

  private get response(): IResponse {
    return {
      answer_id: this.answerId || null,
      answer_value: null,
      question_id: this.question.id || null
    };
  }

  /**
   * Reset to initial state.
   */
  private clear(): void {
    this.answerId = null;
  }

  /**
   * Handle an answer selection.
   */
  private handleAnswerSelect(answerId: number): void {
    if (anime.running.length > 0) return;
    this.answerId = answerId;
    if (this.isLastQuestion) {
      this.handleNext();
    } else {
      this.questionFadeOut.play();
    }
  }

  /**
   * Add the response to store and reset.
   */
  private handleNext(): void {
    if (!this.answerId) return;
    this.$store.dispatch("addResponse", this.response);
    this.$store.dispatch("incrementProgress");
    this.$emit("next");
    this.clear();
  }

  private mounted(): void {
    this.questionFadeOut = anime({
      autoplay: false,
      complete: () => {
        this.handleNext();
      },
      duration: this.DURATION,
      easing: this.EASING,
      loop: false,
      opacity: [1, 0],
      targets: ".question"
    });
    this.questionFadeIn = anime({
      autoplay: false,
      duration: this.DURATION,
      easing: this.EASING,
      opacity: [0, 1],
      targets: ".question"
    });
    if (this.index <= 0) return;
    this.questionFadeIn.play();
  }
}
